import { useState } from 'react';
import { toast } from 'sonner';
import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';

export default function CopyButton({ text, label = 'Copy', size = 'sm', variant = 'outline' }) {
  const [done, setDone] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(String(text ?? ''));
      setDone(true);
      toast.success('Copied');
      setTimeout(() => setDone(false), 1500);
    } catch {
      toast.error('Copy failed. Select the text and copy it by hand.');
    }
  }

  return (
    <Button type="button" variant={variant} size={size} onClick={copy}>
      <ApperIcon name={done ? 'Check' : 'Copy'} size={16} />
      {done ? 'Copied' : label}
    </Button>
  );
}
